import React from 'react'
import Spline from '@splinetool/react-spline'

function ErrorPage() {
  return (
    <div class="err-content">
        <Spline 
          className='Spline'
          scene='https://prod.spline.design/s-Ju3hpzU123GPax/scene.splinecode'
        />
    </div>
  )
}

export default ErrorPage 